// Builds the LendingPad vendor support request text.
//
// This MUST stay byte-for-byte identical to the backend's
// `buildLendingPadVendorRequestBodyPlainText`
// (backend/functions/config/emailTemplates.js) — the same message the backend
// emails to LendingPad support. If the backend template changes, update this too.

const REPLY_TO_EMAIL = "info@addy-ai.com";

/**
 * @param {Object} detail LendingPad operations org detail
 * @returns {string} plain-text vendor request body, identical to the backend
 */
export function buildLendingPadSupportRequest(detail) {
  const organizationName = detail?.name || "your organization";
  const userName =
    detail?.requestedByName || detail?.requesterName || detail?.ownerName || "";
  const userEmail =
    detail?.requestedByEmail ||
    detail?.requesterEmail ||
    detail?.ownerEmail ||
    "";
  const companyId =
    (detail?.draftConfig && detail.draftConfig.company) || detail?.company || "";

  // Identity lines are omitted when unknown rather than showing a placeholder.
  const userNameLine = userName ? `\nUser Name: ${userName}` : "";
  const emailLine = userEmail ? `\nEmail: ${userEmail}` : "";
  const companyLine = companyId ? `\nCompany ID: ${companyId}` : "";
  const exportsAsk = companyId
    ? "Will you please turn on the exports (Loan, Documents, and Conditions) and enable the Get Loans (List Loans) endpoint for this Company ID so we can receive the updates from LendingPad?"
    : "Will you please provide the Company ID for this user, turn on the exports (Loan, Documents, and Conditions), and enable the Get Loans (List Loans) endpoint so we can receive the updates from LendingPad?";

  return `Hello LendingPad Support Team,

We have a mutual customer who would like to enable the Addy AI integration with their LendingPad account:

Company Name: ${organizationName}${userNameLine}${emailLine}${companyLine}

${exportsAsk}

Additionally, once the standard exports are active, please also run an initial bulk export of this customer's existing loan pipeline (through the same Loan export), so their full book reaches Addy without each loan needing to be modified first.

Once we receive these details, we will complete the integration setup on our end.

Thank you for your assistance. Please reply to ${REPLY_TO_EMAIL} once the exports and the Get Loans (List Loans) endpoint have been enabled and the initial bulk export has been queued.

Best regards,
The Addy AI Team`;
}
